import { LatLng } from './types';

/**
 * Where Google should look first when completing an address. Predictions are
 * global by default, so typing "Te" in Helsinki offered Texas, Tennessee and
 * Tenerife before any Finnish street.
 *
 * This is a BIAS, not a filter: `componentRestrictions` would hide everything
 * outside the country, and someone searching for a home abroad would never
 * reach it. A radius around the viewer keeps nearby streets on top while a
 * long-enough query still finds Texas.
 */
const BIAS_RADIUS_M = 60_000;

export const placesSearchOptions = (
  center?: LatLng | null,
): google.maps.places.AutocompletionRequest | undefined => {
  // The Maps SDK loads lazily, and `google.maps.LatLng` is a constructor from
  // it: touching it before load throws and takes the whole search field down.
  if (!center || typeof google === 'undefined' || !google.maps?.LatLng) {
    return undefined;
  }
  return {
    location: new google.maps.LatLng(center.lat, center.lng),
    radius: BIAS_RADIUS_M,
  } as google.maps.places.AutocompletionRequest;
};
